export default __webpack_public_path__ + "src/assets/images/default_extensionCord.png?13a573bc";